import { render, staticRenderFns } from "./OptimumImporter.vue?vue&type=template&id=b20dd7c4"
import script from "./OptimumImporter.vue?vue&type=script&lang=js"
export * from "./OptimumImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports